function composeFields(embed, ...fields) {
    if (embed) {
        const embedUpperCase = embed.toUpperCase();
        return fields.map((_embed) => `${embedUpperCase}.${_embed}`).join();
    }
    return fields.join();
}
function composeEmbeds(...embeds) {
    return embeds.map((_embed) => _embed.toUpperCase()).join();
}
const field = (...fields) => composeFields('', ...fields);
const embedField = (embed, ...fields) => composeFields(embed, ...fields);
const embed = (...embeds) => composeEmbeds(...embeds);
export { field, embedField, embed, };
